import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject, Subscription, takeUntil } from 'rxjs';

import { Account } from '../../../auth/models/account.model';
import { Role } from '../../../auth/models/role.model';
import { User } from '../../../auth/models/user.model';
import { Company } from '../../../models/company.model';
import { ManagerRequest } from '../../../models/manager.model';
import { CompanyService } from '../../../services/company.service';
import { ManagersService } from '../../services/managers.service';

@Component({
  selector: 'ag-managers-request-modal',
  templateUrl: './managers-request-modal.component.html',
  styleUrls: ['./managers-request-modal.component.scss']
})
export class ManagersRequestModalComponent implements OnInit, OnDestroy {

  @ViewChild('requestModal', { static: true }) private readonly requestModal: TemplateRef<any>;

  @Input() public account: Account;
  @Input() public company: Company;
  @Input() public roles: Role[];
  @Input() public user: User;

  @Output() readonly submitted = new EventEmitter();

  // public managerRequest: ManagerRequest;
  // public companies: Company[];

  public selectedCompany: Company;
  public selectedRole: Role;
  /**
   * Flag used to enable/disable UI buttons and links when an API request is in
   * progress.
   */
  public processing: boolean;
  public errors = [];

  private destroy$ = new Subject<void>();
  private modalRef: BsModalRef;
  private modalSub: Subscription;

  /** @ignore */
  constructor(
    public companyService: CompanyService,
    private managersService: ManagersService,
    private modalService: BsModalService
  ) { }

  /** @ignore */
  ngOnInit(): void {
    this.companyService.watchAccount()
      .pipe(takeUntil(this.destroy$))
      .subscribe(account => {
        if (account) this.account = account;
      });
  }

  public show(): void {
    // this.managerRequest = new ManagerRequest();
    this.errors = [];
    this.openModal(this.requestModal);
  }

  public request(): void {
    this.processing = true;
    this.errors = [];

    const account: Account = this.user.accounts.find(account => account.company_id === this.company.id);

    const request = new ManagerRequest({
      company_id: this.selectedCompany.id,
      manager_account_id: account.id,
      manager_role_id: this.selectedRole.id as number
    });

    console.log('request', request)

    this.managersService.request(this.company.id, request)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: () => {
          this.closeModal();
          this.submitted.emit();
        },
        error: (response) => {
          if (typeof response.error.message.ext_company_team_exist !== 'undefined') {
            this.errors.push("TEAM_VIEW.INVITE_MODAL.ALREADY_EXISTS");
          } else {
            this.errors.push("SIGNUP.UNKNOWN_ERROR");
          }
          this.processing = false;
        }
      });
  }

  /** Generic Modal trigger. */
  private openModal(template: TemplateRef<any>, c: string = ''): void {
    this.modalRef = this.modalService.show(template, { class: c, ignoreBackdropClick: true });

    this.modalSub = this.modalRef.onHide
      .pipe(takeUntil(this.destroy$))
      .subscribe((reason: string) => {
        this.modalSub.unsubscribe();
        this.modalRef = undefined;
        // Reset all values
        this.processing = false;
      });
  }

  /** Closes the most recent opened modal. */
  public closeModal(onHide: Function = null): void {
    this.selectedCompany = null;
    this.selectedRole = null;

    if (this.modalRef) {
      this.modalRef.hide();
      if (onHide) this.modalRef.onHide
        .pipe(takeUntil(this.destroy$))
        .subscribe(() => onHide());
    } else {
      if (onHide) onHide();
    }
  }

  /** @ignore */
  ngOnDestroy(): void {
    this.closeModal();

    // Complete all subscriptions using takeUntil pattern
    this.destroy$.next();
    this.destroy$.complete();
  }
}
